import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { categories as categoriesMessages } from 'constants/types';

type Category = {
  name: string | null;
};

type Props = {
  categories: {
    nodes: Category[];
  } | null;
};

const ignoredCategories = ['football', 'nba', 'mlb', 'sorare', 'product'];

export const useDisplayCategories = ({ categories }: Props) => {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    const category = categories?.nodes
      .filter(
        cat => cat.name && !ignoredCategories.includes(cat.name.toLowerCase())
      )
      .find(Boolean);

    const categoryDisplayName =
      category?.name &&
      categoriesMessages[category.name as keyof typeof categoriesMessages]
        ? formatMessage(
            categoriesMessages[category.name as keyof typeof categoriesMessages]
          )
        : formatMessage(categoriesMessages.news);

    return {
      category,
      categoryDisplayName,
    };
  }, [categories, formatMessage]);
};
